/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { useViewport } from "@vlinder-web/viewport-provider-react";

import {
  HeaderComp,
  IHeaderCompProps,
  HeroSection,
  IHeroSectionProps,
  ImageFeature,
  IImageFeatureProps,
  MainSection,
  IMainSectionProps,
  Footer,
  IFooterProps,
  Features,
  IFeaturesProps,
  Sidebar,
  ISidebarProps,
  IHowItWorksProps,
  HowItWorks,
} from "./components";

type IAdminLandingPageType = IHeaderCompProps &
  IHeroSectionProps &
  IImageFeatureProps &
  IMainSectionProps &
  IFooterProps &
  ISidebarProps &
  IHowItWorksProps &
  IFeaturesProps;

export const LandingPage = ({ ...rest }: IAdminLandingPageType) => {
  const { bp, width } = useViewport();

  const _getHeader = () => {
    if (bp === "xs" || width <= 990) {
      return <Sidebar {...rest} />;
    } else {
      return <HeaderComp {...rest} />;
    }
  };

  return (
    <div>
      {_getHeader()}
      <HeroSection {...rest} />
      <ImageFeature {...rest} />
      <HowItWorks {...rest} />
      <MainSection {...rest} />
      <Features {...rest} />
      <Footer {...rest} />
    </div>
  );
};

LandingPage.defaultProps = {};
